import SystemAlertLine from './system-alert-line.component.js'

export * from './system-alert-line.component.js'
export default SystemAlertLine

SystemAlertLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-alert-line': SystemAlertLine
  }
}
